import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Auth from "./Auth";
import AuthFooter from "./AuthFooter";

function IndexAuth() {
  const options = {
    title: "Sign in",
    buttonAction: "Sign in",
    showFooter: true,
    signupAction: "Create an account",
    signupPath: "/auth/signup",
    forgotPassAction: "Forgot Password?",
    forgotPassPath: "/auth/forgotpass",
  };

  return (
    <Container
      style={{
        maxWidth: "450px",
        paddingTop: "2rem",
      }}
    >
      <Card
        className="text-center"
        style={{
          borderRadius: "10px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Card.Header
          as="h5"
          className="d-flex justify-content-center align-items-center"
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "10px 10px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            Sign In
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Auth
            buttonAction={"Login"}
            afterAuthPath={"/"}
            type={"signin"}
            providers={["google"]}
          />
          <AuthFooter
            type={"signin"}
            options={options}
            signupAction={"Create an account"}
            signupPath={"/auth/signup"}
            forgotPassAction={"Forgot Password?"}
            forgotPassPath={"/auth/forgotpass"}
          />
        </Card.Body>
      </Card>
    </Container>
  );
}

export default IndexAuth;
